// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDescriptionStyles } from "@stoneage/Overrides/Components/ProductDescription";
import { css } from "styled-components";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { fontConfig } from "@stoneage/XDL/constants";

const descriptionStyles: TypographyPresentationProps = {
    ...fontConfig.regularSingleLine,
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 0;
        ${wrapInContainerStyles}
    `,
};

productDescriptionStyles.productDetailLink = {
    color: "secondary",
    typographyProps: {
        ...descriptionStyles,
    },
    css: css`
        align-self: baseline;
    `,
};

productDescriptionStyles.productDetailDescription = {
    ...descriptionStyles,
};
